// extracted by mini-css-extract-plugin
export default {"input":"NumberField_input__+p59O"};